import {createAction} from 'Shared/utilities/actionCreator';
import {Dependents} from '../models/Dependents';
import * as D from '../models/Dependents';
import {reverseEnum} from 'Shared/utilities/enumUtility';
import {PhoneNumber} from 'ApplicationEntry/models/PhoneNumber';

import {StringUnion} from 'Core/models/EmptyString';
import {ZipCode} from 'ApplicationEntry/models/ZipCode';
import {Sex} from 'ApplicationEntry/models/Sex';

export enum DependentsActionType {
  UPDATE_DEPENDENT = 'dependents/UPDATE_DEPENDENT',
}

export const updateDependentValues = (
  firstName: StringUnion,
  middleName: StringUnion,
  lastName: StringUnion,
  relationship: StringUnion,
  sex: Sex | '',
  socialSecurityNumber: string,
  dateOfBirth: Date | '',
  phone: PhoneNumber,
  address: StringUnion,
  addressLine2: string,
  city: StringUnion,
  state: StringUnion,
  zip: ZipCode,
  occSmokerCode: StringUnion,
  accidentDependent: boolean,
  cancerDependent: boolean,
  shopDependent: boolean
) =>
  createAction(DependentsActionType.UPDATE_DEPENDENT, {
    firstName,
    middleName,
    lastName,
    relationship,
    sex,
    socialSecurityNumber,
    dateOfBirth,
    phone,
    address,
    addressLine2,
    city,
    state,
    zip,
    occSmokerCode,
    accidentDependent,
    cancerDependent,
    shopDependent,
  });

export type DependentsAction = ReturnType<typeof updateDependentValues>;

export const isDependentsAction = (action: any): action is DependentsAction =>
  action.type in reverseEnum(DependentsActionType);

type DependentsState = Dependents;
const DEFAULT_STATE: DependentsState = D.EmptyDependents;

export default (state: DependentsState = DEFAULT_STATE, action: DependentsAction) => {
  switch (action.type) {
    case DependentsActionType.UPDATE_DEPENDENT:
      return D.updateDependentValues(
        action.payload.firstName,
        action.payload.middleName,
        action.payload.lastName,
        action.payload.relationship,
        action.payload.sex,
        action.payload.socialSecurityNumber,
        action.payload.dateOfBirth,
        action.payload.phone,
        action.payload.address,
        action.payload.addressLine2,
        action.payload.city,
        action.payload.state,
        action.payload.zip,
        action.payload.occSmokerCode,
        action.payload.accidentDependent,
        action.payload.cancerDependent,
        action.payload.shopDependent
      )();
    default:
      return state;
  }
};
